module.exports = __webpack_public_path__ + "static/img/hzhb_zj.cb6aff4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_zj.png
// module id = glWx
// module chunks = 0